<template>
  <div class="infoDiv">
    <div class="h3title">基本信息</div>
    <div class="formbox">
      <el-form class="glo_formBox" label-width="120px">
        <el-form-item label="车次属性:">
          <el-input
            v-model="dialogFormDispatch.dispatchPropertyShow"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="配载批次:">
          <el-input
            v-model="dialogFormDispatch.number"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="预计发车日期:">
          <el-input
            v-model="dialogFormDispatch.planDepartureTime"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="始发网点:">
          <el-input
            v-model="dialogFormDispatch.startDeptName"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="车辆类型:">
          <el-input
            v-model="dialogFormDispatch.carCategory"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="是否牵引车:">
          <el-input
            v-model="dialogFormDispatch.isTractor ? '是' : '否'"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="车型:">
          <el-input
            v-model="dialogFormDispatch.carType"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item required label="车牌号码:">
          <el-input
            v-model="dialogFormDispatch.carNumber"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="挂车号码:">
          <el-input
            v-model="dialogFormDispatch.trailerNumber"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item required label="司机一:">
          <el-input
            v-model="dialogFormDispatch.driverOneName"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item required label="司机一电话:">
          <el-input
            v-model="dialogFormDispatch.driverOnePhone"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="司机一身份证:">
          <el-input
            v-model="dialogFormDispatch.driverOneIdcard"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="司机二:">
          <el-input
            v-model="dialogFormDispatch.driverTwoName"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="司机二电话:">
          <el-input
            v-model="dialogFormDispatch.driverTwoPhone"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="司机二身份证:">
          <el-input
            v-model="dialogFormDispatch.driverTwoIdcard"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="押运员一:">
          <el-input
            v-model="dialogFormDispatch.supercargoOneName"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="押运员二:">
          <el-input
            v-model="dialogFormDispatch.supercargoTwoName"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="随车人员一:">
          <el-input
            v-model="dialogFormDispatch.carFollowPersonnelOneName"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="随车人员二:">
          <el-input
            v-model="dialogFormDispatch.carFollowPersonnelTwoName"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发货员一:">
          <el-input
            v-model="name"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发货员二:">
          <el-input
            v-model="name1"
            disabled
            placeholder="自动生成"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="发车合同号:">
          <el-input
            v-model="dialogFormDispatch.dispatchContractNumber"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="应付合计:">
          <el-input
            v-model="dialogFormDispatch.totalAmount"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="备注:">
          <el-input
            type="textarea"
            v-model="dialogFormDispatch.remarks"
            disabled
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="h3title">运单明细</div>
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems" @click="loadSureMore"
          >装货确认</el-button
        >
        <el-button class="glo_btnItems" @click="unloadSure">卸货确认</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        header-align="center"
        ref="mytable"
        :data="tableDataRight"
        @selection-change="handleSelectionChange1"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard1">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'loadLongitude_loadLatitude' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.loadLongitude }},
                {{ scope.row.loadLatitude }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            v-if="item.field == 'unloadLongitude_unloadLatitude' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.unloadLongitude }},
                {{ scope.row.unloadLatitude }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 弹窗 装货确认-->
    <myDialog
      :diaWidth="diaWidth1"
      :dialogTitle="dialogTitle1"
      :isShowDialog="isShowDialog1"
      @handleCloseDia="handleCloseDia1"
      @diaCancelBtn="handleCloseDia1"
      @diaConfirmBtn="diaConfirmBtn1"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog1"
          class="diaForm"
          ref="dialogForm1"
          :model="dialogForm1"
          label-width="100px"
          :rules="rulesForm1"
        >
          <!-- <el-form-item class="dialogFormItems" prop="aaa" label="活动名称:">
            <el-input v-model="dialogForm1.aaa"></el-input>
          </el-form-item>-->

          <el-form-item
            class="dislogFormTextarea"
            prop="remarks"
            label="已选任务:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm1.taskStr"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm1.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item label="装货图片:">
            <uploadimgs
              @input="changeFileList_zh"
              :fileNameLists="fileNameLists1"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 卸货确认 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog2"
          class="diaForm"
          ref="dialogFormRef"
          :model="dialogForm2"
          label-width="100px"
          :rules="rulesForm2"
        >
          <el-form-item
            class="dialogFormItems"
            prop="unloadType"
            label="卸货类型:"
          >
            <el-select v-model="dialogForm2.unloadType" placeholder="请选择">
              <el-option
                v-for="(item, idx) in unloadTypeList"
                :key="idx"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="returnCangReason"
            label="回仓原因:"
            v-if="dialogForm2.unloadType == 'hui_cang:unload_type'"
          >
            <el-select
              v-model="dialogForm2.returnCangReason"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in returnCangReasonList"
                :key="index"
                :label="item.key"
                :value="item.confDictId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="isOutGoing"
            label="是否外发到站:"
            v-if="dialogForm2.unloadType == 'zheng_chang:unload_type'"
          >
            <el-select v-model="dialogForm2.isOutGoing" placeholder="请选择">
              <el-option
                v-for="(item, idx) in isOutGoingList"
                :key="idx"
                :label="item.name"
                :value="item.val + ''"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            prop="returnCangStorageId"
            label="回仓仓库:"
            v-if="dialogForm2.unloadType == 'hui_cang:unload_type'"
          >
            <el-select
              v-model="dialogForm2.returnCangStorageId"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in storageList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="dialogForm2.isOutGoing == '0'"
            class="dislogFormTextarea"
            prop="remarks"
            label="备注:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="dialogForm2.isOutGoing == '1'"
            class="dislogFormTextarea"
            prop="outgoingRemarks"
            label="外发备注:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.outgoingRemarks"
            ></el-input>
          </el-form-item>
          <el-form-item style="width: 100%" label="卸货图片:">
            <uploadimgs
              @input="changeFileList2"
              :fileNameLists="fileNameLists2"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
          <el-form-item
            style="width: 100%"
            v-if="dialogForm2.isOutGoing == '1'"
            label="外发图片:"
          >
            <uploadimgs
              @input="changeFileList3"
              :fileNameLists="fileNameLists3"
              :limit="9"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  inject: ["reload"],
  components: {
    myDialog,
    uploadimgs,
  },
  props: {
    dispatchId: {
      typeof: String,
      default: "",
    },
  },
  data() {
    return {
      tableData1: [],
      //配载明细
      myTableHeard1: [
        {
          name: "任务编号",
          field: "number",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "指令编号",
          field: "commandNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输类型",
          field: "transportTypeShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运输计划",
          field: "transportPlanShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货地址",
          field: "taskStartAllAddress",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货地址",
          field: "taskEndAllAddress",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "状态",
          field: "taskStatusShow",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "件数",
          field: "packageCout",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积",
          field: "volume",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "运输里程数",
          field: "mileage",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货时间",
          field: "loadTime",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货操作人",
          field: "loadUserName",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货经纬度",
          field: "loadLongitude_loadLatitude",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货时间",
          field: "unloadTime",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货操作人",
          field: "unloadUserName",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货经纬度",
          field: "unloadLongitude_unloadLatitude",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData1: [],
      pageStart: 1,
      pageTotal: 100,
      totalArr: ["packageCout", "grossWeight", "netWeight", "volume"],

      dialogFormDispatch: {},
      isTractorList: [
        //是否牵引车
        { val: 0, name: "否" },
        { val: 1, name: "是" },
      ],
      employeeList: [],
      employeeList2: [],
      employeeList3: [],
      employeeList4: [],
      employeeName1: "",
      employeeName2: "",

      // ==== 弹窗组件属性 start ====
      isShowDialog1: false,
      dialogTitle1: "装货确认",
      diaWidth1: "60%",
      dialogForm1: {
        // 弹窗表单数据
        remarks: "",
        taskStr: "",
      },
      rulesForm1: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      loadSureMoreIds: [],
      fileNameLists1: [], //装货确认

      // ==== 弹窗组件属性 start ====
      isShowDialog2: false,
      dialogTitle2: "",
      diaWidth2: "40%",
      dialogForm2: {
        // 弹窗表单数据
        isOutGoing: "0",
        fileIds: [],
        outgoingFileIds: [],
        outgoingRemarks: "",
        remarks: "",
        returnCangReason: "",
        returnCangStorageId: "",
        taskIds: [],
        unloadType: "",
      },
      rulesForm2: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      isOutGoingList: [
        {
          name: "是",
          val: "1",
        },
        {
          name: "否",
          val: "0",
        },
      ],
      unloadTypeList: [
        {
          name: "正常卸货",
          val: "zheng_chang:unload_type",
        },
        {
          name: "回仓卸货",
          val: "hui_cang:unload_type",
        },
      ],
      returnCangReasonList: [], //回仓原因
      storageList: [],
      fileNameLists3: [], //外发图片
      fileNameLists2: [], //卸货图片
      // ==== 弹窗组件属性 end ====
      name: "",
      name1: "",
      tableDataRight: [],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getObjectUserDownList("storage"); //网点
    this.getConfDictValDownListApi("return_cang_reason"); //回仓原因
  },
  activated() {
    // this.$API
    //   .getReportFileds({
    //     number: "admin_dispatch_detail_driver",
    //   })
    //   .then((res) => {});
    // this.$API
    //   .getReportFileds({
    //     number: "admin_dispatch_detail_waybill",
    //   })
    //   .then((res) => {});
  },
  destroyed() {},
  methods: {
    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    3
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable1.doLayout();
      });
      return sums;
    },
    getDispatchDetailApi() {
      this.$API
        .getDispatchDetail({ dispatchId: this.dispatchId })
        .then((res) => {
          this.dialogFormDispatch = res.data.result[0] || {};
          this.name =
            (this.dialogFormDispatch.notifierReqs &&
              this.dialogFormDispatch.notifierReqs.length &&
              this.dialogFormDispatch.notifierReqs[0].employeeName) ||
            "";
          this.name1 =
            (this.dialogFormDispatch.notifierReqs &&
              this.dialogFormDispatch.notifierReqs.length > 1 &&
              this.dialogFormDispatch.notifierReqs[1].employeeName) ||
            "";
        });
      this.$API
        .wtl_getDispatchTaskList({
          dispatchId: this.dispatchId,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.tableDataRight = res.data.result.data || [];
          // this.$nextTick(() => {
          //   this.fetTableHeight();
          // });
        });
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
      this.fileNameLists1 = [];

      this.dialogForm1 = {
        remarks: "",
        taskStr: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn1() {
      let fileIds = this.fileNameLists1.map((item) => {
        return item.name;
      });
      this.$API
        .wtl_loadSure({
          taskIds: this.loadSureMoreIds,
          fileIds: fileIds || [],
          remarks: this.dialogForm1.remarks || "",
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          // this.getData2();
          this.isShowDialog1 = false;
        });
    },
    // 选择图片(装货确认)
    changeFileList_zh(array) {
      this.fileNameLists1 = array;
    },

    // 装货确认
    loadSureMore() {
      if (this.selectTableData1.length < 1) {
        this.$message.warning("请选择需要装货确认的任务");
        return false;
      }
      let ids = [];
      let str = "";
      this.selectTableData1.forEach((item) => {
        ids.push(item.taskId);
        str += item.number + " , ";
      });
      this.loadSureMoreIds = ids;
      this.dialogForm1.taskStr = str;
      this.isShowDialog1 = true;
    },

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        isOutGoing: "0",
        fileIds: [],
        outgoingFileIds: [],
        outgoingRemarks: "",
        remarks: "",
        returnCangReason: "",
        returnCangStorageId: "",
        taskIds: [],
        unloadType: "",
      };
      this.fileNameLists2 = [];
      this.fileNameLists3 = [];
    },
    //  弹窗确认保存事件(卸货确认)
    diaConfirmBtn2(formName) {
      let param = JSON.parse(JSON.stringify(this.dialogForm2));

      let arr1 = this.fileNameLists2.map((item) => {
        return item.name;
      });
      let arr2 = this.fileNameLists3.map((item) => {
        return item.name;
      });

      param.fileIds = arr1 || [];
      param.outgoingFileIds = arr2 || [];
      this.$API.wtl_unloadSure(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.isShowDialog2 = false;
        // this.getData2();
      });
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array;
    },
    // 选择图片
    changeFileList3(array) {
      this.fileNameLists3 = array;
    },
    // 卸货确认
    unloadSure() {
      if (this.selectTableData1.length < 1) {
        this.$message.warning("请选择需要卸货确认的任务");
        return false;
      }
      let ids = [];
      this.selectTableData1.forEach((item) => {
        ids.push(item.taskId);
      });
      this.dialogForm2.taskIds = ids;
      this.isShowDialog2 = true;
      this.dialogTitle2 = "卸货确认";
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownListApi(type) {
      this.$COMAPI.getConfDictValDownList(type).then((res) => {
        // 回仓原因
        if (type == "return_cang_reason") {
          this.returnCangReasonList = res || [];
        }
      }); //送货方式
    },
    handleSelectionChange1(e) {
      this.selectTableData1 = e;
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "storage") {
          //获取网点列表
          this.storageList = res || [];
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;
.infoDiv {
  margin-bottom: 20px;
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
.textArea {
  height: auto !important;
}
.goodg {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}
</style>
